export enum WhatsappCloudApiMessagingLimitEnum {
  TIER_1K = 'TIER_1K ',
  TIER_10K = 'TIER_10K',
  TIER_100K = 'TIER_100K',
  TIER_UNLIMITED = 'TIER_UNLIMITED',
}
